import React, { useMemo } from 'react';
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize';
import { useOffersListingQuery } from '@hooks';
import { ALL_COLLECTION_SLUG } from '../../../consts/collection';
import { CollectionsView } from './CollectionsView';
import { useCollectionsQuery } from './queries/useCollectionsQuery';
export const CollectionsContainer = () => {
    const { collectionsQuery } = useCollectionsQuery();
    const offerIds = useMemo(() => (collectionsQuery.data || [])
        ?.filter((collection) => collection.slug !== ALL_COLLECTION_SLUG)
        ?.map((collection) => collection.offerIds[0])
        .filter(Boolean), [collectionsQuery.data]);
    const { offersListingQuery } = useOffersListingQuery([
        {
            ids: offerIds,
            size: Math.max(offerIds?.length || 0, 10),
        },
    ], {
        enabled: !!offerIds.length,
    });
    const getThumbnail = (offerIds) => {
        if (!offerIds.length)
            return '';
        return offersListingQuery.data?.offers.find((offer) => offer.id === offerIds[0])?.thumbnail;
    };
    const collections = useMemo(() => collectionsQuery.data
        ?.filter((collection) => collection.slug !== ALL_COLLECTION_SLUG)
        .map((collection) => ({
        ...collection,
        name: decodeHtmlEntities(collection.name),
        thumbnail: getThumbnail(collection.offerIds),
    })), [collectionsQuery.data, offersListingQuery.data]);
    return (React.createElement(CollectionsView, { collections: collections, isFetching: collectionsQuery.isInitialLoading }));
};
